<template>
  <div class="loader" :class="variant" />
</template>

<script>
export default {
  name: 'TinyLoader',
  props: {
    variant: {
      default: 'secondary',
      validator: val => ['primary', 'secondary', 'secondary-black', 'warning', 'danger', 'success', 'discount', 'leumi'].includes(val),
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';

  .loader {
    width: 34px;
    height: 34px;
    border: 4px solid $riseup_white;
    border-top: 4px solid $riseup_blue;
    border-radius: 50%;
    animation: spin 2s linear infinite;

    &.secondary {
      border: 4px solid $riseup_blue;
      border-top: 4px solid $riseup_white;
    }

    &.secondary-black {
      border: 4px solid $riseup_black;
      border-top: 4px solid $riseup_white;
    }

    &.warning {
      border: 4px solid $riseup_yellow;
      border-top: 4px solid $riseup-white;
    }

    &.danger {
      border: 4px solid $riseup_danger_red;
      border-top: 4px solid $riseup_white;
    }

    &.success {
      border: 4px solid $riseup_green;
      border-top: 4px solid $riseup_white;
    }

    &.discount {
      border: 4px solid $discount_green;
      border-top: 4px solid $riseup-white;
    }

    &.leumi {
      border: 4px solid $riseup_white;
      border-top: 4px solid $leumi_blue;
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
